import './UIButton.scss';
import UIFlex, { copyFlex, IFlex, IUIFlexProps } from './UIFlex';
import {IconifyIcon} from '@iconify/react'
import UIIcon from './UIIcon';
import Flex from '../data/Flex';
import Size from '../data/Size';
import Color from '../data/Color';
import { PropsWithChildren, useState } from 'react';
import UIPopup, { IUIPopupProps } from './UIPopup';

export interface IUIButtonProps extends IUIFlexProps {
    color?:string;
    size?:string;
    fontSize?:string;
    label?:string | JSX.Element;
    icon?:IconifyIcon | string;
    iconClassName?:string;    
    iconFontSize?:string;
    dropShadow?:boolean;
    noPadding?:boolean;
    isSquare?:boolean;
    borderRadius?:number;
    disabled?:boolean;
    disabledWhy?:string | JSX.Element;
    onInsideClick?:()=>void;
    insideChildren?:JSX.Element;
    useButton?:boolean;
    fullWidth?:boolean;
    path?:string;
}

export default function UIButton($props:IUIButtonProps){

    let cn:string = Size.addSizeAndFontSize("button",$props.size,$props.fontSize);
    let cnInside:string = "inside";
    
    let usePadding=true;
    if($props.noPadding || $props.isSquare){
        usePadding=false;
    }
    let color = $props.color || Color.PRIMARY;
    if($props.className)    cn+=" "+$props.className;
    if($props.disabled)     cn+=" disabled";
    if(usePadding)          cn+=" hasPadding";
    if($props.isSquare)     cn+=" isSquare";
    if($props.dropShadow)   cn+=" hasDropShadow";
    
    if($props.label){
        cn+=" hasLabel";
        cnInside+=" hasLabel";
    }   
    if($props.onInsideClick){
        cn+=" hasInsideDiv";
        cnInside+=" isBtnBG";
        cnInside+=" color_"+color;
    }else{
        cn+=" color_"+color;
        cn+=" isBtnBG";
    }

    let elementType = UIFlex.TYPE_DIV;
    if($props.useButton){
        elementType = UIFlex.TYPE_BUTTON;
    }

    let flex:IFlex | undefined = copyFlex({direction:Flex.ROW,inline:true, elementType:elementType}, $props.flex);
    let insideFlex:IFlex | undefined = undefined;

    if($props.onInsideClick){
        insideFlex = flex;
        flex = undefined;
    }

    let content:JSX.Element = (
        <>
            {$props.label && (
                <div className="btnLabel">
                    {$props.label}
                </div>
            )}
            {$props.icon && (
                <UIIcon fontSize={$props.iconFontSize} className={"btnIcon "+($props.iconClassName || "")} icon={$props.icon}/>
            )}        
        </>
    );


    return (
        <UIFlex 
            path={$props.path}
            onClick={$props.onClick}
            flex={flex}
            className={cn}>                
            {$props.onInsideClick && (
                <UIFlex onClick={$props.onInsideClick} className={cnInside} flex={insideFlex}>
                    {$props.insideChildren}
                    {content}
                </UIFlex>
            )}
            {!$props.onInsideClick && content}  
            {$props.children}
        </UIFlex>
    );
}

interface IUICloseButtonProps{
    onClick?:()=>void;
    size?:string;
    fs?:string;
    className?:string;
}
export function UICloseButton($props:IUICloseButtonProps){
    return (
        <UIButton className={"closeBtn"+($props.className?" "+$props.className:"")} size={$props.size || Size.s36} fontSize={$props.fs || Size.s24} color={Color.TRANSPARENT} isSquare noPadding icon={UIIcon.CLOSE} onClick={$props.onClick}/>
    );
}

export interface IUIButtonWPopupProps extends PropsWithChildren{
    button:IUIButtonProps;
    popup:IUIPopupProps;
    hideCloseBtn?:boolean;
    
}

export function UIButtonWPopup($props:IUIButtonWPopupProps){
    const [showing, setShowing] = useState(false);  
    const {onInsideClick:dontNeed1, children:buttonChildren, ...theRestButton} = $props.button;
    const {onCloseClick:dontNeed2, showing:dontNeed3, children:popupChildren, ...theRestPopup} = $props.popup;
    const children = popupChildren || $props.children;




    return(
        <UIButton {...theRestButton} onInsideClick={()=>{
            setShowing(!showing);
        }}>
            {buttonChildren}
            <UIPopup 
                {...theRestPopup}
                hideCloseBtn={$props.hideCloseBtn}
                onCloseClick={()=>{
                    setShowing(false);
                }} 
                showing={showing}
            >
                {children}
            </UIPopup>
        </UIButton>
    )
}
